
import { se_1_1of4_PAaA, se_1_2of4_PAaA, xyz_1_1of4, xyz_1_2of4, xyz_1_3of4, xyz_n_4of4, xyz_n_4of4_PAaA } from './SL44000Sprint01TTR'
import { list24500Sprint01 } from '../ActivityLists/AL24500Sprint01'

import { breakoutStandard } from './SLSprint00'

// Object-Oriented Programming (OOP) sprint 1 values.
const sprint = 1
const activityList = () => { return list24500Sprint01(sprint) }

const oop_1_1of4 = () => { return xyz_1_1of4(sprint, activityList, se_1_1of4_PAaA, se_1_2of4_PAaA.prework) }
const oop_1_2of4 = () => { return xyz_1_2of4(sprint, activityList, se_1_2of4_PAaA, oop_1_3of4_PAaA.prework) }

const breakoutOOPConceptsAndPracticesName = 'OOP Concepts and Practices'
const breakoutOOPConceptsAndPractices = () => { 
	return breakoutStandard(
		`Breakout: ${breakoutOOPConceptsAndPracticesName}`, 
		'In this breakout session your team will discuss', [
		'Encapsulation (Information Hiding), Inheritance (Abstraction), and Polymorphism',
		'Composition & Aggregation',
		'Class & Object',
		'Event Driven Programming (Execution Model)'
	])
}
export const oop_1_3of4_PAaA = {
	'prework':[
		'Make your initial Discussion 1 post',
		'Complete through activity 10 prior to next class', 
		'Focus on Object-Oriented Programming Concepts and Practices ',
		'... they are a BIG deal!',
		`Be prepared for “${breakoutOOPConceptsAndPracticesName}” breakout`,
		'Be prepared for Quiz 1' ],
	'announcements':[
		'Your initial Discussion 1 post was due two days ago',
		'All sprint 1 activities and assignments due Sunday!',
		`In-person attendance is required next Tuesday for Sprint ${sprint+1} Planning` ],
	'agenda':[
		'Sprint Progress Polling',
		`Breakout: ${breakoutOOPConceptsAndPracticesName}`,
		'Prework for Next Class',	
		'Quiz 1' ]
}
const oop_1_3of4 = () => { return xyz_1_3of4(sprint, activityList, oop_1_3of4_PAaA, oop_1_4of4_PAaA.prework, breakoutOOPConceptsAndPractices) }

const oop_1_4of4_PAaA = xyz_n_4of4_PAaA('Complete through activity 14', sprint)
const oop_1_4of4 = () => { return  xyz_n_4of4(sprint, activityList, oop_1_4of4_PAaA, oop_2_1of4_PAaA.prework, breakoutOOPConceptsAndPractices ) }

const oop_2_1of4_PAaA = { 
	'prework':[ 
		'Everything is due Sunday!', '',
		`Be prepared for Sprint ${sprint} Planning` ],
	'announcements':[ 
		`Sprint ${sprint} starts now.` ],
	'agenda':[ 
		`Sprint ${sprint} Planning`,
		`Sprint ${sprint} Planning Breakout`,
		'Review Demos and Demo Schedule',
		'Upcoming Changes to the Course Structure',
		'Prework for Next Class' ]
}

export const oop_1_slidedeckTTR = [ oop_1_1of4, oop_1_2of4, oop_1_3of4, oop_1_4of4 ]